import { TripRequestEmbedRead } from 'src/common/external/bambi-api/bambiApi';
import { BAMBI_API_BASE_URL } from 'src/common/external/bambi-api/constants';

export const EMBED_COPY_WARNING =
  'Copy this entire code block as-is. Do not extract the URL to use as a link. It will not work.';

export function generateTripRequestEmbedHTML(
  tripRequestEmbed: TripRequestEmbedRead
) {
  return `<!-- IMPORTANT: ${EMBED_COPY_WARNING} -->
<iframe
  title="Trip Request Form"
  src="${BAMBI_API_BASE_URL}public/trips/embed/trip-request/?access_token=${tripRequestEmbed.public_token}"
  style="
    width: 100%;
    height: 100%;
  "
></iframe>
`;
}
